export default "__VITE_ASSET__D0n3LlzR__"